import APIClient from '@/shared/http/clients/api'

const resourceName = 'empresa'
const APICore = process.env.APIBaseURLCore

const GetEmpresa = (config = {}) => APIClient.get(`${APICore}/${resourceName}/GetEmpresa`, config)
const GetAllEmpresa = (nome, config = {}) => APIClient.get(`${APICore}/${resourceName}/GetAllEmpresa/${nome}`, config)
const GetAllEmpresabyCodigo = (nome, config = {}) => APIClient.get(`${APICore}/${resourceName}/GetAllEmpresabyCodigo/codigo/${nome}`, config)

const CompanyRepository = {
  GetEmpresa,
  GetAllEmpresa,
  GetAllEmpresabyCodigo
}

export default CompanyRepository



// WEBPACK FOOTER //
// ./src/shared/http/repositories/access/company.js